<template>
  <div class="fix-list px-3 pt-3 pb-2">
    <div v-for="(item, index) in items" :key="index" class="fix-item">
      <h3 class="title mb-3">{{ index + 1 }}. {{ item.order_item_name }}</h3>
      <div class="d-flex justify-content-between mb-3">
        <div>
          <div class="label">{{ $t("feature.homecare.fix_status") }}</div>
          <div
            :class="[item.order_item_status_code]"
            class="value status homecare-status"
          >
            {{ $t("feature.homecare.status." + item.order_item_status_code) }}
          </div>
        </div>
        <div v-if="item.new_job_order_id">
          <div class="label">{{ $t("feature.homecare.fix_note") }}</div>
          <div class="value">
            {{
              $t("feature.homecare.fix_new") + " " + item.new_job_order_id ||
              "-"
            }}
          </div>
        </div>
      </div>
      <div class="description mb-3">
        <div class="label">{{ $t("feature.homecare.description") }}</div>
        <div class="value">{{ item.joborder_item_note || "-" }}</div>
      </div>
      <div class="images">
        <sc-thumbnail
          v-for="(image, imageIndex) in item.order_item_images"
          :key="imageIndex"
          :img-src="image.image_url"
          :open-link="true"
          img-class="sc-image p-0 me-2 mb-2"
        ></sc-thumbnail>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from "@/components/helper/Thumbnail"

export default {
  components: {
    "sc-thumbnail": Thumbnail,
  },
  props: {
    items: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.fix-item {
  padding: 16px;
  background: #f9f9f9;
  border-radius: 15px;
  margin-bottom: 8px;
}
h3.title {
  font-size: 16px;
  font-weight: bold;
  margin: 0 0 6px 0;
}
.description {
  font-size: 16px;
  font-weight: 500;
  color: #4a4a4a;
}
.images {
  display: flex;
  flex-wrap: wrap;
  .sc-image {
    border-radius: 13.6px;
    position: relative;
    width: 100px;
    height: 100px;
    overflow: hidden;
  }
}
.label {
  font-size: 11px;
  font-weight: 500;
  color: #8c8786;
  margin-bottom: 8px;
}
.value {
  font-size: 16px;
  font-weight: 500;
}
.status {
  font-size: 16px;
  font-weight: bold;
}
</style>
